import styled from "styled-components";
import { xmd, md, sm } from "../../../AppTheme.styled";

type IHeading = { spacing?: number | [number, number] };

const getSpacing = (spacing?: number | [number, number]) => {
  if (!spacing) return "0";
  if (typeof spacing === "number") {
    return `${spacing * 8}px 0px`;
  }
  return `${spacing[0] * 8}px 0px ${spacing[1] * 8}px 0`;
};

export const H1 = styled.h1<IHeading>`
  font-size: 48px;
  margin: ${({ spacing }) => getSpacing(spacing)};
`;

export const H2 = styled.h2<IHeading>`
  font-size: 30px;
  margin: ${({ spacing }) => getSpacing(spacing)};

  ${sm} {
    font-size: 36px;
  }
`;

export const H3 = styled.h3<IHeading>`
  font-size: 24px;
  margin: ${({ spacing }) => getSpacing(spacing)};
`;

export const H4 = styled.h4<IHeading>`
  font-size: 16px;
  line-height: 160%;
  ${sm} {
    font-size: 20px;
    line-height: 120%;
  }
  margin: ${({ spacing }) => getSpacing(spacing)};
`;

export const H5 = styled.h5<IHeading>`
  font-size: 16px;
  margin: ${({ spacing }) => getSpacing(spacing)};
`;

export const H6 = styled.h6<IHeading>`
  font-size: 14px;
  margin: ${({ spacing }) => getSpacing(spacing)};
`;
